export default "https://cdn-static.gokick.com/assets/0f3104c02f0c7e58561d070a1e1ba5e916429e4c/images/sleep-bottles.21ff427124b73aa7b2cf5884e65ef589.jpg";